import { render, staticRenderFns } from "./DeleteMovie.vue?vue&type=template&id=9cd3b906&scoped=true&"
import script from "./DeleteMovie.vue?vue&type=script&lang=js&"
export * from "./DeleteMovie.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMovie.vue?vue&type=style&index=0&id=9cd3b906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd3b906",
  null
  
)

component.options.__file = "DeleteMovie.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
